/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArtistAliasCreateSourceIds } from './ArtistAliasCreateSourceIds';
import {
    ArtistAliasCreateSourceIdsFromJSON,
    ArtistAliasCreateSourceIdsFromJSONTyped,
    ArtistAliasCreateSourceIdsToJSON,
} from './ArtistAliasCreateSourceIds';

/**
 * 
 * @export
 * @interface ArtistBandUpdate
 */
export interface ArtistBandUpdate {
    /**
     * 
     * @type {string}
     * @memberof ArtistBandUpdate
     */
    stageName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistBandUpdate
     */
    manualStageName?: boolean;
    /**
     * 
     * @type {ArtistAliasCreateSourceIds}
     * @memberof ArtistBandUpdate
     */
    sourceIds?: ArtistAliasCreateSourceIds;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistBandUpdate
     */
    isPermanentMember?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistBandUpdate
     */
    isMainPerformer?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArtistBandUpdate
     */
    linkedAliasId?: string | null;
}

/**
 * Check if a given object implements the ArtistBandUpdate interface.
 */
export function instanceOfArtistBandUpdate(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ArtistBandUpdateFromJSON(json: any): ArtistBandUpdate {
    return ArtistBandUpdateFromJSONTyped(json, false);
}

export function ArtistBandUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistBandUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stageName': !exists(json, 'stageName') ? undefined : json['stageName'],
        'manualStageName': !exists(json, 'manualStageName') ? undefined : json['manualStageName'],
        'sourceIds': !exists(json, 'source_ids') ? undefined : ArtistAliasCreateSourceIdsFromJSON(json['source_ids']),
        'isPermanentMember': !exists(json, 'is_permanent_member') ? undefined : json['is_permanent_member'],
        'isMainPerformer': !exists(json, 'is_main_performer') ? undefined : json['is_main_performer'],
        'linkedAliasId': !exists(json, 'linked_alias_id') ? undefined : json['linked_alias_id'],
    };
}

export function ArtistBandUpdateToJSON(value?: ArtistBandUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stageName': value.stageName,
        'manualStageName': value.manualStageName,
        'source_ids': ArtistAliasCreateSourceIdsToJSON(value.sourceIds),
        'is_permanent_member': value.isPermanentMember,
        'is_main_performer': value.isMainPerformer,
        'linked_alias_id': value.linkedAliasId,
    };
}

